import React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';
import { Box, InputAdornment, useTheme } from '@mui/material';

import { CustomInput } from '../CustomInput';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000 00 00"
      definitions={{
        '#': /[1-9]/
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export const CustomInputWithMask = ({ disabled, ...props }) => {
  const theme = useTheme();
  const currentColor = disabled ? theme.palette.grey[1000] : 'text.primary';

  return (
    <CustomInput
      InputProps={{
        inputComponent: TextMaskCustom,
        startAdornment: (
          <InputAdornment position="start" sx={{ marginRight: '16px' }}>
            <Box
              component="span"
              sx={{
                position: 'relative',
                display: 'inline-block',
                borderRight: '1px solid',
                borderRightColor: 'action.disabled',
                paddingRight: '16px',
                color: currentColor
              }}>
              +7
            </Box>
          </InputAdornment>
        )
      }}
      disabled={disabled}
      {...props}
    />
  );
};

CustomInputWithMask.propTypes = {
  disabled: PropTypes.bool
};
